/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import { Button, Checkbox, FormControlLabel, FormControl, FormHelperText, TextField, Typography, makeStyles, MenuItem } from '@material-ui/core';
import { GRANT_WEB_ACCESS_FAILURE, GRANT_WEB_ACCESS_SUCCESS, RESEND_WELCOME_EMAIL_FAILURE, RESEND_WELCOME_EMAIL_SUCCESS, UPDATE_INTAKE_RECORD_FAILURE, UPDATE_INTAKE_RECORD_SUCCESS } from '../types';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from '../../layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { grantWebAccess, getIntakeSummaries, resendWelcomeEmail, setEEIntakeStatus, updateIntakeRecord } from '../intake.actions';
import { showToast } from 'modules/layout/layout.actions';
import PropTypes, { nominalTypeHack } from 'prop-types';
import React, { useEffect, useState } from 'react';

import Dialog from 'modules/common/dialog.component';
import Spinner from 'modules/common/spinner.component';
import { convertPhoneNumber, grabCountryCode } from '../details/authorizationIntake/utils';
import { COUNTRY_CODES } from 'modules/common/countryCodes';

const useStyles = makeStyles((theme) => ({
  mobileNum: {
    marginRight: 10,
  },
  email: {
    minWidth: 175,
  },
  countryCode: {
    maxWidth: 145,
    marginRight: 10,
  }
}));

function WebAccessAlterationsDialog(props) {

  const classes = useStyles(props);

  const {
    onSubmit,
    onCancel,
    maxLength,
    disabled,
    record,
    ...rest
  } = props;
  const [eeIntakeRequired, setEEIntakeRequired] = useState(props.record?.intakeRecord?.transfereeIntakeRequired || false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [primaryEmail, setPrimaryEmail] = useState('');
  const [noMobileNum, setNoMobileNum] = useState(props.record?.intakeRecord?.noMobileNumber || false);
  const [isSaving, setIsSaving] = useState(false);
  const [isResendingWelcomeEmail, setIsResendingWelcomeEmail] = useState(false);
  const [grantingAccess, setGrantingAccess] = useState(false);
  const [countryCode, setCountryCode] = useState('');

  // Only check moveType when record is loaded; if not loaded yet, don't show error
  const moveTypeExists = !props.record || (props.record.intakeRecord.moveTypeId !== null && props.record.intakeRecord.moveTypeId !== undefined);
  const noWebAccess = props.record && (!props.record.intakeRecord?.transferreeHasWebAccess || props.record.intakeRecord?.transferreeHasWebAccess === false);

  const handleSave = async () => {
    const record = props.record;

    if (record) {
      // If record has nested intakeRecord (V2 structure), it means it wasn't flattened properly
      // Extract the actual intake record data
      const actualRecord = record.intakeRecord ? {
        ...record.intakeRecord,
        contacts: record.contacts,
        pets: record.pets,
        phoneNumbers: record.phones,
        emailAddresses: record.emails,
        notes: record.notes,
        authorizationComments: record.authorizationComments,
        miscTimelineEntries: record.miscTimelineEntries,
        departureProperty: record.departureProperty,
        intakeHhgServiceDetail: record.hhgServiceDetail,
        destinationServiceInfo: record.destinationServiceInfo,
        temporaryLivingInfo: record.temporaryLivingInfo,
        relocationAllowance: record.relocationAllowance,
        homesaleProcess: record.homesaleProcess,
        hhgBenefitsTimeline: record.hhgBenefitsTimeline,
        spousalAssistance: record.spousalAssistance,
        houseHunting: record.houseHuntingInfo,
        finalMove: record.finalMoveInfo,
        candidateInternInfo: record.candidateInternInfo,
      } : record;

      // Handle both property names (V2 API uses phones/emails, flattened uses phoneNumbers/emailAddresses)
      const phonesList = actualRecord.phoneNumbers || actualRecord.phones || [];
      const emailsList = actualRecord.emailAddresses || actualRecord.emails || [];
      
      const originalMobile = phonesList.find((o) => o.phoneTypeId === 1);
      const originalEmail = emailsList.find((o) => o.isPrimary === true);

      const diffMobile = originalMobile?.phoneNumber !== mobileNumber && mobileNumber?.length > 0;
      const diffEmail = originalEmail?.emailAddress !== primaryEmail && primaryEmail?.length > 0;
      actualRecord.transfereeIntakeRequired = eeIntakeRequired;
      actualRecord.noMobileNumber = noMobileNum;

      // Ensure we're working with phoneNumbers and emailAddresses (flattened format)
      if (!actualRecord.phoneNumbers && actualRecord.phones) {
        actualRecord.phoneNumbers = actualRecord.phones;
        delete actualRecord.phones;
      }
      if (!actualRecord.emailAddresses && actualRecord.emails) {
        actualRecord.emailAddresses = actualRecord.emails;
        delete actualRecord.emails;
      }

      if (diffMobile) {
        if (originalMobile) {
          actualRecord.phoneNumbers.find((o) => o.phoneTypeId === 1).phoneNumber = mobileNumber;
        } else {
          actualRecord.phoneNumbers.push({
            phoneNumber: mobileNumber,
            phoneTypeId: 1,
            contactInfoOwnerTypeId: 1,
            isPrimary: false,
          });
        }
      }
            
      if (diffEmail) {
        if (originalEmail) {
          actualRecord.emailAddresses.find((o) => o.isPrimary === true).emailAddress = primaryEmail;
        } else {
          actualRecord.emailAddresses.push({
            emailAddress: primaryEmail,
            emailTypeId: 0,
            contactInfoOwnerTypeId: 1,
            isPrimary: true,
          });
        }
      }

      const webAccessReq = {
        Id: actualRecord.id || actualRecord.Id,
        AuthorizationID: actualRecord.mtAuthorizationId || actualRecord.MtAuthorizationId,
        NoMobileNumber: noMobileNum,
        EmailAddress: primaryEmail,
        PhoneNumber: mobileNumber,
      };

        // make the update call, wait on it then grantwebaccess
        // Use actualRecord now that we've properly flattened it
        const updatePayload = {
          ...actualRecord,
          phoneNumbers: actualRecord.phoneNumbers,
          emailAddresses: actualRecord.emailAddresses,
          transfereeIntakeRequired: actualRecord.transfereeIntakeRequired,
          noMobileNumber: actualRecord.noMobileNumber,
        };
        const updateResponse = await props.updateIntakeRecord(updatePayload);
        if (updateResponse.type === UPDATE_INTAKE_RECORD_FAILURE) {
          props.showToast('Failed to save data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setGrantingAccess(false);
          return;
        } else {
          if(!actualRecord.transferreeHasWebAccess) {
            const resp = await props.grantWebAccess(webAccessReq);
            if (resp.type === GRANT_WEB_ACCESS_SUCCESS) {
              if (eeIntakeRequired) await props.setEEIntakeStatus(actualRecord.id || actualRecord.Id, true);
              // Refresh summaries to show updated web access status
              await props.getIntakeSummaries();
              props.showToast(`Successfully saved and granted web access for authorization: ${actualRecord.mtAuthorizationId}`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
              onCancel();
            } else if (resp.type === GRANT_WEB_ACCESS_FAILURE) {
              props.showToast(`Failed to grant web access for authorization: ${actualRecord.mtAuthorizationId}`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
              onCancel();
            }
          }
          else {
            // Refresh summaries to show updated web access status
            await props.getIntakeSummaries();
            props.showToast(`Successfully saved web access info for authorization: ${actualRecord.mtAuthorizationId}`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
          }
        }
    }
    setIsSaving(false);
  }


  const handleResendWelcomeEmail = async () => {
    const record = props.record;

    setIsResendingWelcomeEmail(true);
    if (record) {
      // If record has nested intakeRecord (V2 structure), it means it wasn't flattened properly
      // Extract the actual intake record data
      const actualRecord = record.intakeRecord ? {
        ...record.intakeRecord,
        contacts: record.contacts,
        pets: record.pets,
        phoneNumbers: record.phones,
        emailAddresses: record.emails,
        notes: record.notes,
        authorizationComments: record.authorizationComments,
        miscTimelineEntries: record.miscTimelineEntries,
        departureProperty: record.departureProperty,
        intakeHhgServiceDetail: record.hhgServiceDetail,
        destinationServiceInfo: record.destinationServiceInfo,
        temporaryLivingInfo: record.temporaryLivingInfo,
        relocationAllowance: record.relocationAllowance,
        homesaleProcess: record.homesaleProcess,
        hhgBenefitsTimeline: record.hhgBenefitsTimeline,
        spousalAssistance: record.spousalAssistance,
        houseHunting: record.houseHuntingInfo,
        finalMove: record.finalMoveInfo,
        candidateInternInfo: record.candidateInternInfo,
      } : record;

      // Handle both property names (V2 API uses phones/emails, flattened uses phoneNumbers/emailAddresses)
      const phonesList = actualRecord.phoneNumbers || actualRecord.phones || [];
      const emailsList = actualRecord.emailAddresses || actualRecord.emails || [];
      
      const originalMobile = phonesList.find((o) => o.phoneTypeId === 1);
      const originalEmail = emailsList.find((o) => o.isPrimary === true);

      const diffMobile = originalMobile?.phoneNumber !== mobileNumber && mobileNumber?.length > 0;
      const diffEmail = originalEmail?.emailAddress !== primaryEmail && primaryEmail?.length > 0;
      actualRecord.transfereeIntakeRequired = eeIntakeRequired;
      actualRecord.noMobileNumber = noMobileNum;

      // Ensure we're working with phoneNumbers and emailAddresses (flattened format)
      if (!actualRecord.phoneNumbers && actualRecord.phones) {
        actualRecord.phoneNumbers = actualRecord.phones;
        delete actualRecord.phones;
      }
      if (!actualRecord.emailAddresses && actualRecord.emails) {
        actualRecord.emailAddresses = actualRecord.emails;
        delete actualRecord.emails;
      }

      if (diffMobile) {
        if (originalMobile) {
          actualRecord.phoneNumbers.find((o) => o.phoneTypeId === 1).phoneNumber = mobileNumber;
        } else {
          actualRecord.phoneNumbers.push({
            phoneNumber: mobileNumber,
            phoneTypeId: 1,
            contactInfoOwnerTypeId: 1,
            isPrimary: false,
          });
        }
      }
            
      if (diffEmail) {
        if (originalEmail) {
          actualRecord.emailAddresses.find((o) => o.isPrimary === true).emailAddress = primaryEmail;
        } else {
          actualRecord.emailAddresses.push({
            emailAddress: primaryEmail,
            emailTypeId: 0,
            contactInfoOwnerTypeId: 1,
            isPrimary: true,
          });
        }
      }

      const webAccessReq = {
        Id: actualRecord.id || actualRecord.Id,
        AuthorizationID: actualRecord.mtAuthorizationId || actualRecord.MtAuthorizationId,
        NoMobileNumber: noMobileNum,
        EmailAddress: primaryEmail,
        PhoneNumber: mobileNumber,
      };

      if (diffEmail || diffMobile) {
        // make the update call, wait on it then grantwebaccess
        // Use actualRecord now that we've properly flattened it
        const updatePayload = {
          ...actualRecord,
          phoneNumbers: actualRecord.phoneNumbers,
          emailAddresses: actualRecord.emailAddresses,
          transfereeIntakeRequired: actualRecord.transfereeIntakeRequired,
          noMobileNumber: actualRecord.noMobileNumber,
        };
        const updateResponse = await props.updateIntakeRecord(updatePayload);
        if (updateResponse.type === UPDATE_INTAKE_RECORD_FAILURE) {
          props.showToast('Failed to save data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          setIsResendingWelcomeEmail(false);
          return;
        } else if (updateResponse.type === UPDATE_INTAKE_RECORD_SUCCESS) {
          const resp = await props.resendWelcomeEmail(webAccessReq);
          if (resp.type === RESEND_WELCOME_EMAIL_SUCCESS) {

            if (eeIntakeRequired) await props.setEEIntakeStatus(actualRecord.id || actualRecord.Id, true);

            // Refresh summaries to show updated web access status
            await props.getIntakeSummaries();
            props.showToast(`Successfully saved web access info and resent welcome email for authorization: ${actualRecord.mtAuthorizationId}`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
            onCancel();
          } else if (resp.type === RESEND_WELCOME_EMAIL_FAILURE) {
            props.showToast(`Failed to save web access info and resend welcome email for authorization: ${actualRecord.mtAuthorizationId}`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
            onCancel();
          }
        }
      } else {
        const resp = await props.resendWelcomeEmail(webAccessReq);
        if (resp.type === RESEND_WELCOME_EMAIL_SUCCESS) {

          if (eeIntakeRequired) await props.setEEIntakeStatus(actualRecord.id || actualRecord.Id, true);

          // Refresh summaries to show updated web access status
          await props.getIntakeSummaries();
          props.showToast(`Successfully saved web access info and resent welcome email for authorization: ${actualRecord.mtAuthorizationId}`, { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
          onCancel();
        } else if (resp.type === RESEND_WELCOME_EMAIL_FAILURE) {
          props.showToast(`Failed to save web access info and resend welcome email for authorization: ${actualRecord.mtAuthorizationId}`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          onCancel();
        }
      }
    }
    setIsResendingWelcomeEmail(false);
  };

  useEffect(() => {
    setCountryCode('');
    setMobileNumber('');
    setPrimaryEmail('');

    if (props.record || props.summaryRecord) {
      // Fallback: use webAccessMobileNumber from summary if available, otherwise pull from phoneNumbers
      const summaryMobile = props.summaryRecord?.webAccessMobileNumber;
      // V2 API uses phones at root level
      const recordMobile = props.record?.phones?.find((o) => o.phoneTypeId === 1)?.phoneNumber;
      const number = (summaryMobile && summaryMobile.trim()) ? summaryMobile : recordMobile;
      
      // Fallback: use webAccessEmailAddress from summary if available, otherwise pull from emailAddresses
      const summaryEmail = props.summaryRecord?.webAccessEmailAddress;
      // V2 API uses emails at root level
      const recordEmail = props.record?.emails?.find((o) => o.isPrimary === true)?.emailAddress;
      const email = (summaryEmail && summaryEmail.trim()) ? summaryEmail : recordEmail;
      
      if (number) {
        let tempCountryCode = grabCountryCode(number);
        setCountryCode(tempCountryCode);
        setMobileNumber(convertPhoneNumber(number, tempCountryCode));
      }
      if (email) setPrimaryEmail(email);
      if(props.record?.intakeRecord?.transfereeIntakeRequired)
      {
        setEEIntakeRequired(props.record.intakeRecord.transfereeIntakeRequired);
      }
      if(props.record?.intakeRecord?.noMobileNumber)
      {
        setNoMobileNum(props.record.intakeRecord.noMobileNumber)
      }
    }
  }, [props.record, props.summaryRecord]);

  let countryOptions = [];
  if (COUNTRY_CODES) {
    countryOptions = COUNTRY_CODES.map((country) => ({
      value: country['alpha-3'],
      label: country.name,
    }));
  }

  return (
    <Dialog
      {...rest}
      title="Alter Web Access"
      content={
        <div>
          {props.record && (
            <div>
              <Typography>{props.summaryRecord?.name || `${props.record.contacts?.[0]?.firstName || ''} ${props.record.contacts?.[0]?.lastName || ''}`}</Typography>
              <Typography>{props.summaryRecord?.clientName || ''}</Typography>
              <div>
                <TextField
                  select
                  label="Country"
                  className={classes.countryCode}
                  value={countryCode}
                  onChange={(e) => { setCountryCode(e.target.value); setMobileNumber(convertPhoneNumber(mobileNumber, e.target.value)); }}
                  SelectProps={{
                    autoWidth: true,
                  }}
                  variant="outlined"
                >
                  {countryOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  type="text"
                  name="mobileNumber"
                  label="Mobile Number"
                  variant="outlined"
                  value={convertPhoneNumber(mobileNumber, countryCode)}
                  onChange={(e) => setMobileNumber(convertPhoneNumber(e.target.value, countryCode))}
                  className={classes.mobileNum}
                  disabled={noMobileNum}
                />
                <TextField
                  type="text"
                  name="emailAddress"
                  label="Email Address"
                  variant="outlined"
                  value={primaryEmail}
                  onChange={(e) => setPrimaryEmail(e.target.value)}
                  className={classes.email}
                  disabled={true}
                />
              </div>
              <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'noMobileNum'}
                    name={'noMobileNum'}
                    label={'Confirm No Mobile Number'}
                    labelPlacement="end"
                    control={<Checkbox />}
                    checked={noMobileNum}
                    variant="standard"
                    margin="dense"
                    sx={{ minWidth: '180px', maxWidth: '360px' }}
                    onClick={(e) =>
                      setNoMobileNum( e.target.checked ? true : false )
                    }
                  />   
                </FormControl>
                <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                  <FormControlLabel
                    key={'eeIntakeRequired'}
                    name={'eeIntakeRequired'}
                    label={'Make Questionnaire Available to EE'}
                    labelPlacement="end"
                    control={<Checkbox />}
                    checked={eeIntakeRequired}
                    variant="standard"
                    margin="dense"
                    sx={{ minWidth: '180px', maxWidth: '360px' }}
                    disabled={props.record.intakeRecord?.transfereeIntakeSubmitted}
                    onClick={(e) => {
                      if (props.record && !props.record.intakeRecord?.transfereeIntakeSubmitted) setEEIntakeRequired( e.target.checked ? true : false )
                    }}
                  />   
                </FormControl>
            </div>
          )}
          {!props.record && (
            <Spinner />
          )}
          {props.record && !moveTypeExists && <FormHelperText error>You must set the MoveType before enabling Web Access for this authorization.</FormHelperText>}
          {/*{(noWebAccess) && <FormHelperText error>Web Access has not been granted for this authorization. Please verify phone number or email to be correct, then select 'Resend ReloSource Invitation'.</FormHelperText>}*/}
        </div>
      }
      actions={
        <>
          {(isSaving || isResendingWelcomeEmail || grantingAccess) && (
            <div style={{ padding: '1.25rem', display: 'flex', justifyContent: 'center', width: '100%' }}>
              <Spinner />
            </div>
          )}
          {!(isSaving || isResendingWelcomeEmail || grantingAccess) && (
            <>
              <Button disabled={disabled} onClick={onCancel} variant="outlined" color="primary">Close</Button>
              <Button disabled={!props.record || (!moveTypeExists)} onClick={handleResendWelcomeEmail} variant="contained" color="primary">Resend ReloSource Invitation</Button>
              <Button disabled={!props.record || (!moveTypeExists)} onClick={handleSave} variant="contained" color="primary">Save Changes</Button>
            </>
          )}
        </>
      }
    />
  );
}

WebAccessAlterationsDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  record: PropTypes.object,
  summaryRecord: PropTypes.object,
};

export default compose(
  connect(null, {
    grantWebAccess,
    getIntakeSummaries,
    resendWelcomeEmail,
    setEEIntakeStatus,
    showToast,
    updateIntakeRecord,
  }),
)(WebAccessAlterationsDialog);